import { useId } from 'react';

/**
 * A document-unique id for an SVG fragment (gradient, filter, clipPath...).
 *
 * On web every `<Svg>` renders into the one DOM, so a hardcoded id collides as soon as the
 * component is mounted twice - and `url(#id)` then resolves to whichever copy comes first in
 * document order. React Navigation keeps the previous screen mounted under `display: none`,
 * so the copy that wins is usually the invisible one and the paint silently falls back:
 * gradients go flat, patterns and filters disappear. Suffixing the id per instance keeps each
 * `<Svg>` pointing at its own defs.
 *
 * `useId()` emits colons, which are not valid in a fragment identifier, so they are stripped.
 */
export const useSvgId = (name: string) => `${name}${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;

export default useSvgId;
